//#region src/alert_type.ts
var AlertType = /* @__PURE__ */ function(AlertType) {
	AlertType[AlertType["KioskDown"] = 1] = "KioskDown";
	AlertType[AlertType["KioskTurnedOffManually"] = 2] = "KioskTurnedOffManually";
	AlertType[AlertType["Ordering"] = 3] = "Ordering";
	AlertType[AlertType["SendingOrderItem86d"] = 4] = "SendingOrderItem86d";
	AlertType[AlertType["GenericSendingOrder"] = 5] = "GenericSendingOrder";
	AlertType[AlertType["SendingOrderTimeout"] = 6] = "SendingOrderTimeout";
	AlertType[AlertType["UncommittedTransactions"] = 7] = "UncommittedTransactions";
	AlertType[AlertType["SendingWebhookError"] = 8] = "SendingWebhookError";
	AlertType[AlertType["KioskInactive"] = 9] = "KioskInactive";
	return AlertType;
}(AlertType || {});
//#endregion
export { AlertType };

//# sourceMappingURL=alert_type.js.map